import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../store/store";

const initialState: any = {
  isOpen: true,
};

const sidebarSlice = createSlice({
  name: "sidebarState",
  initialState: initialState,
  reducers: {
    setState(state, action) {
      state.isOpen = action.payload.isOpen;
    },
    toggleMenu(state) {
      state.isOpen = !state.isOpen;
    },
  },
});

export const selectSidebarState = (state: RootState) => state.sidebarState;
export const { setState, toggleMenu } = sidebarSlice.actions;
export default sidebarSlice.reducer;
